export default "__VITE_ASSET__b5841c04__"